export default {
  WELCOME_TO_REACT: "Welcome to React and react-i18next",
}
